import { type TTranscription } from '@core/models'
import { convertTranscription } from '@core/converters'

import { useAudioScreenLoaderData } from './useAudioScreenLoaderData'

export const useAudioScreenTranscription = (): TTranscription | undefined => {
    const { transcription } = useAudioScreenLoaderData()

    return transcription ? convertTranscription(transcription) : undefined
}
